import React, { forwardRef } from 'react'

import clsx from 'clsx'

import styles from './Container.module.scss'

/** @type {import("./types").default} */
const Container = forwardRef(({ component, className, maxWidth, children, fixedWidth, ...otherProps }, ref) => {
  const Component = component || 'div'

  return (
    <Component
      ref={ref}
      className={clsx('Container', styles.root, className, {
        [styles[`container-${maxWidth}`]]: maxWidth && !fixedWidth,
        [styles.fixedWidth]: fixedWidth,
      })}
      {...otherProps}
    >
      {children}
    </Component>
  )
})

export default Container
